export const InheritanceModes = {
    Root: 0,
    DocumentTab: 1,
}
